import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import DatatableSection from "../../components/datatableSection/DatatableSection";
import ClientReportHome from "./components/ClientReportHome";

const ClientReport = () => {
  return (
    <>
      <Sidebar />

      <MainSection>
        <SectionHeader title="ClientReport"/>

        {/* Table structure for jQuery DataTable */}

        <DatatableSection>
          <ClientReportHome />
        </DatatableSection>
      </MainSection>
    </>
  );
};

export default ClientReport;
